import React from "react";

export function Loader({ full = true }) {
  return (
    <div className={`flex items-center justify-center ${full ? "min-h-screen" : "py-20"} bg-brand-navy`} data-testid="loader">
      <div className="relative h-14 w-14">
        <div className="absolute inset-0 rounded-full border-2 border-brand-cyan/20" />
        <div className="absolute inset-0 rounded-full border-t-2 border-brand-cyan animate-spin" />
      </div>
    </div>
  );
}
